var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import styled from '@emotion/styled';
import { Flex, Text, Icon } from 'shared/components/ui';
import { TrackedClick } from 'shared/features/analytics';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  pointer-events: ", ";\n  cursor: ", ";\n"], ["\n  width: 100%;\n  pointer-events: ", ";\n  cursor: ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'auto');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'default' : 'pointer');
});
/**
 * The SideNav link item component
 *
 * @param {NavItemProps} props - The props to pass to the component
 * @param {NavItemProps.title} props.title - The title of the individual SideNav item
 * @param {NavItemProps.url} props.url - The url to navigate to when the item is clicked
 * @param {NavItemProps.activeIcon} props.activeIcon - A React.ReactNode icon to display when the item is active
 * @param {NavItemProps.icon} props.icon - A React.ReactNode icon to display when the item is not active
 * @param {NavItemProps.isActive} props.isActive - A boolean indicating whether the nav item is in an active state
 * @param {NavItemProps.isDisabled} props.isDisabled - A boolean indicating whether the nav item is in an disabled state
 * @returns
 */
export var NavItem = function (_a) {
    var icon = _a.icon, title = _a.title, activeIcon = _a.activeIcon, badgeIcon = _a.badgeIcon, url = _a.url, onclick = _a.onclick, isActive = _a.isActive, isDisabled = _a.isDisabled, badgeColor = _a.badgeColor;
    var clickableSection = (_jsxs(Flex, __assign({ position: "relative", p: "15px 0 8px 0", flexDir: "column", "data-testid": title, w: "100%", alignItems: "center", _hover: { backgroundColor: "".concat(isActive || isDisabled ? '' : 'gray.300') }, color: isActive && !isDisabled ? 'green.500' : isDisabled ? 'gray.350' : 'gray.500', backgroundColor: isActive && !isDisabled ? 'rgba(6, 132, 100, 0.1)' : '' }, { children: [badgeIcon && (_jsx(Icon, { position: "absolute", right: 3, top: 2, color: badgeColor, as: badgeIcon, boxSize: 3 })), _jsxs(Flex, __assign({ direction: "column", align: "center", h: "100%" }, { children: [_jsx(Icon, { as: isActive && !isDisabled ? activeIcon : icon, boxSize: 4 }), _jsx(Text, __assign({ fontWeight: isActive && !isDisabled ? 600 : 400, fontSize: 14, textStyle: "navLink" }, { children: title }))] }))] })));
    if (url) {
        return (_jsx(Wrapper, __assign({ disabled: isDisabled, title: title }, { children: _jsx(TrackedClick, __assign({ eventName: "Sidenav Item", eventProperties: {
                    spring_doc_id: 'compass014',
                } }, { children: _jsx(NavLink, __assign({ to: url }, { children: clickableSection })) })) })));
    }
    else {
        return (_jsx(Wrapper, __assign({ disabled: isDisabled, title: title }, { children: _jsx(TrackedClick, __assign({ eventName: "Sidenav Item", eventProperties: {
                    spring_doc_id: 'compass014',
                } }, { children: _jsx("div", __assign({ onClick: isDisabled ? undefined : onclick }, { children: clickableSection })) })) })));
    }
};
var templateObject_1;
